import script from "./cl-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./cl-avatar.vue?vue&type=script&setup=true&lang=ts"

import "./cl-avatar.vue?vue&type=style&index=0&id=2cea7730&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cea7730"]])

export default __exports__